module.exports = __webpack_public_path__ + "media/2-11.6454d131.mp4";